import { listResearchLibCategories } from 'services/researchLib/listCategories';
import { type ResearchLibCategoryT, useAsyncData } from 'utils';

type UseResearchLibCategoriesResT = {
  items: ResearchLibCategoryT[];
  loading: boolean;
};

export default function useResearchLibCategories():
UseResearchLibCategoriesResT {
  const cats = useAsyncData(
    'researchLib.categories',
    listResearchLibCategories,
  );

  return {
    items: cats.data ?? [],
    loading: cats.loading,
  };
}
